import { RouteConfig } from "vue-router";
import Index from './components/index.vue';
import { mainRoute, InjectRoutes } from "@/router";

const routes: Array<RouteConfig> = [
  {
    path: "Utenti",
    name: "Utenti",
    component:Index,
    meta: { title: "Utenti", showExpander: false, requireAuth: true }
  },
];


export default routes;